<script>
import MainTargetTemplate from './main-target-template.vue';
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Switches from "vue-switches";
import Swal from "sweetalert2";
import ApiType from "@/components/modals/api-type.vue";
import { Carousel, Slide } from "vue-carousel";

export default {
    name: "PlanningTemplate",
    components: {
        MainTargetTemplate,
        MaskedInput,
        Switches,
        ApiType,
        Carousel,
        Slide,
    },
    props: {
        itemClassifications: {
            type: Array,
            required: true
        },
        indicators: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            submitted: false,
            filter: "",
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 20, 50, 100],
            filterBy: 'all',
            apiData: [],
            apiLoading: false,
            modalTitle: '',
            selectedDU: null,
            addApi: false,
            viewingApi: false,
            parentIndicator: null,
            currencyMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: false,
                allowDecimal: true,
            }),
            target: {
                id: 0,
                indicatorItemId: null,
                description: null,
                overAllTarget: null,
                isPercentage: null,
                allowAdd: null,
            },
            api: {
                id: 0,
                planningTemplateDeliveryUnitId: null,
                name: null,
                description: null,
                apiTypeId: null,
                priority: null,
                apiType: null,
            },
            reportList: false,
            slideNum: 1,
            campusSelection: false,
            groupCampus: '',
            allCampus: this.$store.state.decrypt.campusAccessList(),
        };
    },
    validations: {
        target: {
            indicatorItemId: {
                required,
            },
            description: {
                required,
            },
            overAllTarget: {
                required,
            },
        },
        api: {
            name: {
                required,
            },
            description: {
                required,
            },
            apiTypeId: {
                required,
            },
        }
    },
    computed: {
        filtered() {
            let data = this.indicators;
            var total = this.currentPage * this.perPage;
            if (this.filterBy === "all") {
                if (this.filter.trim() != "" && this.filter) {
                    data = data.filter((item) => {
                        return item.filterKey
                            .toUpperCase()
                            .includes(this.filter.toUpperCase());
                    });
                }
            } else {
                data = data.filter((item) => {
                    return item.searchClass.includes(this.filterBy) && item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            data = data.slice(total - this.perPage, total);
            return data;
        },
        rows(){
            let data = this.indicators;
            if (this.filterBy === "all") {
                if (this.filter.trim() != "" && this.filter) {
                    data = data.filter((item) => {
                        return item.filterKey
                            .toUpperCase()
                            .includes(this.filter.toUpperCase());
                    });
                }
            } else {
                data = data.filter((item) => {
                    return item.searchClass.includes(this.filterBy) && item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        },
    },
    methods: {
        openFI(row){
            row.openFI = !row.openFI;
        },
        filteredIndicatorItems(data) {
            let filteredData = [];
            if (this.filterBy === "all") {
                filteredData = data;
            } else {
                filteredData = data.filter((item) =>  item.indicatorItemClassification.classification === this.filterBy);
            }
            if (this.filter && this.filter.trim() != "") {
                filteredData = filteredData.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return filteredData;
        },
        viewAPIs(row){
            this.selectedDU = row;
            this.modalTitle = 'View APIs';
            this.$bvModal.show("api-modal");
            this.addApi = false;
            this.viewingApi = false;
            this.getAPI(row, 'template');
        },
        async getAPI(row, type){
            this.apiLoading = true;
            this.apiData = [];
            if(type === 'template'){
                await this.$store
                    .dispatch(
                        "planningtemplateapi/GetPlanningTemplateApi",
                        row.id
                    )
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.map((item) => {
                            item.editMode = false;
                        });
                        this.apiData = res.data;
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }else{
                await this.$store
                    .dispatch(
                        "api/GetApiByTarget",
                        row.id
                    )
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        if(!res.data.map){
                            return;
                        }
                        res.data.map((item) => {
                            item.editMode = false;
                        });
                        this.apiData = res.data;
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            this.apiLoading = false;
        },
        async viewMainTargets(row){
            row.visible = !row.visible;
            if(row.visible){
                row.mainTargetLoading = true;
                await this.$store
                    .dispatch(
                        "planningmaintarget/GetMainTargetByIndicator",
                        {indicatorItemId: row.id, cycle: this.$store.state.data.cycle, campusId: this.$store.state.data.selectedCampus.id}
                    )
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.forEach(item => {
                            item.visible = false;
                            item.addDU = false;
                            item.mandatoryVisible = false;
                            item.mandatoryApis = cloneDeep(this.mandatoryApis);
                            item.targetTemplateDeliveryUnits = [];
                            item.loadDU = false;
                        })
                        row.mainTargets = res.data;
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
                row.mainTargetLoading = false;
            }
        },
        createNewTarget(row) {
            this.parentIndicator = row;
            this.onResetTarget(row);
            this.modalTitle = "Create New Target";
            this.$bvModal.show("create-target-modal");
        },
        onResetTarget(row) {
            this.target = {
                id: 0,
                planningTemplateId: 0,
                indicatorItemId: cloneDeep(row.id),
                description: "",
                overAllTarget: "",
                isPercentage: row.isPercentage,
                allowAdd: false,
            };
        },
        async onCreateTarget() {
            this.submitted = true;
            this.$v.target.$touch();
            if (this.$v.target.$invalid) {
                return;
            }
            let data = cloneDeep(this.target);
            data.overAllTarget = this.getExactAmt(this.target.overAllTarget);
            data.cycle = this.$store.state.data.cycle;
            data.campusId = this.$store.state.data.selectedCampus.id;
            if (this.target.id > 0) {
                await this.$store
                    .dispatch(`planningmaintarget/UpdateMainTarget`, data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(
                                res.data.errorMessage,
                                "error"
                            );
                        }
                        this.parentIndicator.mainTargets.splice(this.mainTargetIndex, 1, data);
                        this.$bvModal.hide("create-target-modal");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                await this.$store
                    .dispatch(`planningmaintarget/CreateMainTarget`, data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(
                                res.data.errorMessage,
                                "error"
                            );
                        }
                        res.data.targetTemplateDeliveryUnits = [];
                        res.data.visible = false;
                        res.data.addDU = false;
                        res.data.loadDU = false;
                        res.data.mandatoryVisible = false;
                        res.data.mandatoryApis = cloneDeep(this.mandatoryApis);
                        this.parentIndicator.mainTargets.push(res.data);
                        this.$bvModal.hide("create-target-modal");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }

            this.submitted = false;
        },
        async updateIndicatorItem(row, parent){
            this.parentIndicator = parent;
            this.target = cloneDeep(row);
            this.target.overAllTarget = row.overAllTarget.toString();
            this.mainTargetIndex = parent.mainTargets.indexOf(row);
            this.modalTitle = "Update Main Target";
            this.$bvModal.show("create-target-modal");
        },
        async postIndicatorItem(row, parent){
            let index = parent.mainTargets.indexOf(row);
            Swal.fire({
                title: "Are you sure?",
                text: `You want to post this to cycle ${this.$store.state.data.cycle}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, post it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch(
                            "planningmaintarget/PostMainTarget",
                            row.id
                        )
                        .then((res) => {
                            parent.mainTargets[index].status = "Posted";
                            this.showToast(
                                "Successfully posted!",
                                "success"
                            );
                        })
                        .catch((err) => {
                            this.showToast("Cannot be posted!", "error");
                        });
                    }
                });
        },
        deleteIndicatorItem(row, parent){
            let index = parent.mainTargets.indexOf(row);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch(
                            "planningmaintarget/DeleteMainTarget",
                            row.id
                        )
                        .then((res) => {
                            if (res.status == 204) {
                                parent.mainTargets.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted!",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        resetApi(){
            this.api = {
                id: 0,
                planningTemplateDeliveryUnitId: 0,
                name: '',
                description: '',
                apiTypeId: '',
                priority: false,
                apiType: {
                    type: '',
                },
            };
            this.$v.api.$reset();
        },
        addMoreApi(){
            this.addApi = !this.addApi;
            if(this.addApi){
                this.resetApi();
            }
        },
        showApiType(){
            this.$bvModal.show("api-type-modal");
        },
        
        dropType(row){
            this.api.apiType = row;
            this.api.apiTypeId = row.id;
        },
        async saveApi(){
            this.submitted = true;
            this.$v.api.$touch();
            if (this.$v.api.$invalid) {
                return;
            }
            let data = cloneDeep(this.api);
            data.planningTemplateDeliveryUnitId = this.selectedDU.id;
            if(this.api.id == 0){
                await this.$store
                .dispatch(
                    "planningtemplateapi/CreatePlanningTemplateApi",
                    data
                )
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.apiType = this.api.apiType;
                    res.data.editMode = false;
                    this.apiData.push(res.data);
                    this.addApi = false;
                    this.showToast("Successfully added!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            }else{
                await this.$store
                .dispatch(
                    "planningtemplateapi/UpdatePlanningTemplateApi",
                    data
                )
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = this.apiData.findIndex((item) => item.id == this.api.id);
                    this.api.editMode = false;
                    this.apiData.splice(index, 1, this.api);
                    this.showToast("Successfully updated!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            }
        },
        updateApi(row){
            row.editMode = true;
            this.api = cloneDeep(row);
            this.api.apiType = cloneDeep(row.apiType);
        },
        deleteApi(row){
            let index = this.apiData.indexOf(row);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.value) {
                    await this.$store
                        .dispatch(
                            `planningtemplateapi/DeletePlanningTemplateApi`,
                            row.id
                        )
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            this.apiData.splice(index, 1);
                            this.showToast("Successfully deleted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        renderSelection(){
            this.reportList = true;
            this.slideNum = 1;
            this.$nextTick(() => {
                this.$refs.carousel.goToPage(0);
            });
        },
        templateReport() {
            this.$emit('templateReport');
        },
        goToSelection(type){
            this.campusSelection = false;
            this.reportType = type;
            this.slideNum = 2;
            this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
            this.campusSelection = true;
        },
        goBackToSelection(){
            this.slideNum = 1;
            this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
        },
        generateSystemLIB(){
            this.reportList = false;
            this.$emit('generateSystemLIB');
        },
        generateSystemKPI(){
            this.reportList = false;
            this.$emit('generateSystemKPI');
        },
        generateApprovedKPI(){
            this.reportList = false;
            this.$emit('generateApprovedKPI');
        },
        generateTargetSubmissionDates(){
            this.reportList = false;
            this.$emit('generateTargetSubmissionDates', this.groupCampus)
        },
        generateKPIReport(){
            this.reportList = false;
            this.$emit('generateKPIReport', this.groupCampus)
        },
        generateCascadeReport(){
            this.reportList = false;
            this.$emit('generateCascadeReport', this.groupCampus)
        },
        generateCampusLIB(){
            this.reportList = false;
            this.$emit('generateCampusLIB', this.groupCampus)
        },
        filteredPrexc(items){
            let data = items;
            if (this.filterBy == "all") {
                if (this.filter.trim() != "" && this.filter) {
                    data = data.filter((item) => {
                        return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                    });
                }
                return data;
            } else {
                return data.filter((item) => {
                    return item.searchClass.includes(this.filterBy) && item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
        },
        showGrpDtls(row) {
            row.rotateChevy = !row.rotateChevy;
            if(row.rotateChevy){
                 if(this.filter && this.filter.trim() !== ""){
                    this.getIndicatorItems(this.filteredTab(row.items)[0]);
                }else{
                    this.getIndicatorItems(row.items[0]);
                }
            }
        },
        async getIndicatorItems(row) {
            row.indicatorItemLoading = true;
            row.fetchedIndicatorItems = [];
            await this.$store
                .dispatch("indicatoritem/GetParentIndicatorItem", {
                    id: row.id, 
                    cycle: this.$store.state.data.cycle, 
                    campusId: this.$store.state.data.selectedCampus.id, 
                })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = 1;
                    res.data.map((x) => {
                        x.index = index;
                        x.indicatorItemVisibility = false;
                        x.visible = false;
                        x.mainTargetVisible = false;
                        x.mainTargets = [];
                        x.mainTargetLoading = false;
                        x.singleSelection = true;
                        x.selectedTargets = [];
                        x.isSelected = false;
                        x.filterKey = `${row.prexcClassification} ${row.prexc} ${row.indicatorName} ${x.indicatorItemName}`
                        if(x.childItems.length > 0){
                            this.recurseCheckChild(x.childItems, index, row)
                        }
                        x.children = x.childItems;
                        index++;
                    });
                    row.fetchedIndicatorItems = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            row.indicatorItemLoading = false;
        },
        recurseCheckChild(node, value, parent) {
            for(var i = 0, count = node.length; i < count; i++) {
                let item = node[i];
                item.index = value + "." + (i + 1);
                item.children = item.childItems;
                item.indicatorItemVisibility = false;
                item.targetVisible = false;
                item.detailVisible = false;
                item.mainTargetVisible = false;
                item.mainTargets = [];
                item.mainTargetLoading = false;
                item.singleSelection = true;
                item.selectedTargets = [];
                item.isSelected = false;
                item.filterKey = `${parent.prexcClassification} ${parent.prexc} ${parent.indicatorName} ${item.indicatorItemName}`;
                if(item.childItems.length > 0){
                    this.recurseCheckChild(item.childItems, item.index, parent)
                }
            }
        },
        filteredTab(arr){
            let data = arr;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data;
        }
    }
}
</script>
<template>
    <div>
        <b-modal
            id="create-target-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreateTarget"
                autocomplete="off"
                class="needs-validation"
                ref="targetForm"
            >
                
                <div class="mb-3">
                    <label for="target-description"
                        >Target Description</label
                    >
                    <textarea
                        id="target-description"
                        class="form-control"
                        rows="5"
                        v-model="target.description"
                        placeholder="Enter Target Description"
                        :class="{
                            'border-danger':
                                !target.description &&
                                submitted,
                        }"
                    ></textarea>
                </div>
                <div>
                    <label for="overall-target"
                        >Overall Target</label
                    >
                    <masked-input
                        id="overall-target"
                        type="text"
                        class="form-control w-100"
                        placeholder="Overall Target"
                        v-model="target.overAllTarget"
                        :mask="currencyMask"
                        :class="{
                            'border-danger':
                                !target.overAllTarget &&
                                submitted,
                        }"
                    ></masked-input>
                </div>
                <div class="mt-3 d-flex align-items-center">
                    <div class="d-flex align-items-center me-2">
                        <switches
                            v-model="target.isPercentage"
                            id="isPercentage"
                        ></switches>
                        <label for="isPercentage" class="mx-2">
                            <span v-if="target.isPercentage"
                                >Percentage</span
                            >
                            <del v-else>Percentage</del>
                        </label>
                    </div>
                    <div class="d-flex align-items-center">
                        <switches
                            v-model="target.allowAdd"
                            id="isPercentage"
                            color="success"
                        ></switches>
                        <label for="isPercentage" class="mx-2">
                            <span v-if="target.allowAdd"
                                >Allow Add</span
                            >
                            <del v-else>Allow Add</del>
                        </label>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('create-target-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="api-modal"
            :title="modalTitle"
            size="xl"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <ul>
                <li>
                    <b class="font-size-14">Main Target:</b> <span class="font-size-16"><u>{{ selectedDU && selectedDU.description }}</u></span>
                </li>
                <li>
                    <b class="font-size-14">Delivery Unit:</b> <span class="text-warning font-size-16">{{ selectedDU && selectedDU.deliveryUnit.name }}</span>
                </li>
            </ul>
            <table class="table table-bordered ">
                <thead>
                    <tr>
                        <th width="40%">
                            <div class="d-flex">
                                API Name/Description
                                <button 
                                type="button"
                                class="
                                    btn
                                    btn-warning
                                    btn-sm
                                    px-2
                                    py-0
                                    ms-1
                                "
                                v-if="!viewingApi"
                                @click="addMoreApi"
                                >
                                    <template v-if="!addApi">
                                        <i class="bx bx-plus"></i>Add More
                                    </template>
                                    <template v-else>
                                        <i class="bx bx-x"></i>Cancel
                                    </template>
                                </button>
                            </div>
                        </th>
                        <th :width="viewingApi && '20%'">API Type</th>
                        <th v-if="!viewingApi" class="text-center" :width="!addApi ? '90px' : '10%' ">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="!apiLoading && apiData.length == 0 && !addApi">
                        <td :colspan="!viewingApi ? 3 : 2" class="text-center">No Data Found</td>
                    </tr>
                    <template v-if="!apiLoading && apiData.length > 0">
                        <template v-for="x in apiData">
                            <tr :key="`parent-not-edit-${x.id}`" v-if="!x.editMode">
                                <td>
                                    <div>{{ x.name }}</div>
                                    <small>{{x.description}}</small>
                                </td>
                                <td>
                                    {{x.apiType.type}}
                                </td>
                                <td class="align-middle" v-if="!viewingApi">
                                    <div class="
                                            d-flex
                                            justify-content-center
                                            align-items-center
                                        ">
                                        <button type="button" title="Edit" class="btn btn-link p-0 font-size-16 me-1" @click="updateApi(x)">
                                            <i class="bx bx-edit"></i>
                                        </button>
                                        <button type="button" title="Delete" class="btn btn-link p-0 font-size-16"  @click="deleteApi(x)">
                                            <i class=" bx bx-trash text-danger"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr :key="`parent-edit-${x.id}`" v-else>
                                <td>
                                    <input
                                        type="text"
                                        class="form-control mb-3"
                                        v-model="api.name"
                                        placeholder="Enter API Name"
                                        :class="{
                                            'is-invalid':
                                                submitted && $v.api.name.$error,
                                        }"
                                    />
                                    <textarea
                                        rows="3"
                                        class="form-control"
                                        v-model="api.description"
                                        placeholder="Enter API Description"
                                        :class="{
                                            'is-invalid':
                                                submitted && $v.api.description.$error,
                                        }"
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        class="form-control cursor-pointer"
                                        v-model="api.apiType.type"
                                        placeholder="Click to Select Api Type"
                                        readonly
                                        @click="showApiType"
                                        :class="{
                                            'is-invalid':
                                                submitted && $v.api.apiTypeId.$error,
                                        }"
                                    />
                                </td>
                                <td class="text-center" v-if="!viewingApi">
                                    <button
                                        type="button"
                                        class="btn btn-success"
                                        @click="saveApi"
                                    >
                                        <i class="bx bx-save"></i> Save
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-clear"
                                        @click="x.editMode = false"
                                    >
                                        <i class="bx bx-x"></i> Cancel
                                    </button>
                                </td>
                            </tr>
                        </template>
                    </template>
                    <template v-if="addApi">
                        <tr>
                            <td>
                                <input
                                    type="text"
                                    class="form-control mb-3"
                                    v-model="api.name"
                                    placeholder="Enter API Name"
                                    :class="{
                                        'is-invalid':
                                            submitted && $v.api.name.$error,
                                    }"
                                />
                                <textarea
                                    rows="3"
                                    class="form-control"
                                    v-model="api.description"
                                    placeholder="Enter API Description"
                                    :class="{
                                        'is-invalid':
                                            submitted && $v.api.description.$error,
                                    }"
                                />
                            </td>
                            <td>
                                <input
                                    type="text"
                                    class="form-control cursor-pointer"
                                    v-model="api.apiType.type"
                                    placeholder="Click to Select Api Type"
                                    readonly
                                    @click="showApiType"
                                    :class="{
                                        'is-invalid':
                                            submitted && $v.api.apiTypeId.$error,
                                    }"
                                />
                            </td>
                            <td class="text-center">
                                <button
                                    type="button"
                                    class="btn btn-success"
                                    @click="saveApi"
                                >
                                    <i class="bx bx-save"></i> Save
                                </button>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </b-modal>
        <div
            class="card position-relative border shadow mt-2"
        >
            <div class="card-header px-3 pt-3">
                <div class="d-flex align-center justify-content-between">
                    <h4
                        class="card-title mb-0"
                        :id="'template-' + $store.state.data.selectedCampus.id + '-' + $store.state.data.cycle"
                    >
                        FY {{ $store.state.data.cycle }} Cascaded
                        <div>
                            <span class="badge bg-success ms-1">{{
                                $store.state.data.selectedCampus.campusName
                            }}</span>
                        </div>
                    </h4>
                    <div class="d-flex align-center">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-end"
                        >
                            <label
                                class="d-inline-flex align-items-center"
                            >
                                <b-form-input
                                    autocomplete="off"
                                    v-model="filter"
                                    type="search"
                                    placeholder="Search KRA/DYNAMIC/PREXC..."
                                    class="form-control"
                                    style="width:300px"
                                ></b-form-input>
                                <b-dropdown
                                    menu-class="dropdown-menu-end"
                                    variant="black"
                                    toggle-class="p-0"
                                >
                                    <template v-slot:button-content>
                                        <a
                                            href="javascript:void(0);"
                                            class="
                                                font-size-20
                                                mx-2
                                                text-dark
                                            "
                                            ><i class="bx bx-slider"></i
                                        ></a>
                                    </template>
                                    <b-dropdown-item
                                        @click="filterBy = 'all'"
                                    >
                                        <div class="d-flex">
                                            <div style="width: 20px">
                                                <i
                                                    class="bx bx-check"
                                                    v-if="
                                                        filterBy ===
                                                        'all'
                                                    "
                                                ></i>
                                            </div>
                                            All
                                        </div>
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        v-for="x in itemClassifications"
                                        :key="x.id"
                                        @click="
                                            filterBy = x.classification
                                        "
                                    >
                                        <div class="d-flex">
                                            <div style="width: 20px">
                                                <i
                                                    class="bx bx-check"
                                                    v-if="
                                                        filterBy ===
                                                        x.classification
                                                    "
                                                ></i>
                                            </div>
                                            {{ x.classification }}
                                        </div>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </label>
                        </div>
                        <a
                            href="javascript:void(0);"
                            class="
                                font-size-20
                                mx-2
                                text-dark
                            "
                            id="select-report"
                            @click="renderSelection"
                            ><i class="bx bx-printer me-1"></i>
                        </a>
                        <b-popover
                            :target="`select-report`"
                            triggers="click"
                            placement="left"
                            :show.sync="reportList"
                            custom-class="popover-report"
                        >
                            <template v-slot:title>
                                <div
                                    class="
                                        d-flex
                                        align-items-center
                                        justify-content-between
                                    "
                                >
                                    <small>Report List</small>
                                    <span
                                        class="
                                            bx bx-x
                                            font-size-14
                                            cursor-pointer
                                        "
                                        @click="reportList = false"
                                    ></span>
                                </div>
                            </template>
                            <carousel
                                ref="carousel"
                                class="events navs-carousel custom-carousel"
                                id="timeline-carousel"
                                :navigation-enabled="false"
                                :pagination-enabled="false"
                                :perPage="1"
                                :autoplay="false"
                                :minSwipeDistance="0"
                                :mouseDrag="false"
                            >
                                <slide>
                                    <div v-if="slideNum == 1">
                                        <!-- <div>
                                            <a
                                                href="javascript:void(0);"
                                                @click="templateReport"
                                                class="
                                                    font-size-12
                                                    text-dark
                                                    hoverable-link
                                                "
                                                >Planning Template Report</a
                                            >
                                        </div>
                                        <hr class="my-1" /> -->
                                        <!-- <div>
                                            <a
                                                href="javascript:void(0);"
                                                @click="goToSelection('kpi')"
                                                class="
                                                    font-size-12
                                                    text-dark
                                                    hoverable-link
                                                "
                                                >Campus KPI</a
                                            >
                                        </div>
                                        <hr class="my-1" />
                                        <div>
                                            <a
                                                href="javascript:void(0);"
                                                @click="goToSelection('cascaded')"
                                                class="
                                                    font-size-12
                                                    text-dark
                                                    hoverable-link
                                                "
                                                >Cascaded KPI</a
                                            >
                                        </div>
                                        <hr class="my-1" />
                                        <div>
                                            <a
                                                href="javascript:void(0);"
                                                @click="goToSelection('campus')"
                                                class="
                                                    font-size-12
                                                    text-dark
                                                    hoverable-link
                                                "
                                                >Campus LIB</a
                                            >
                                        </div>
                                        <hr class="my-1" />
                                        <div>
                                            <a
                                                href="javascript:void(0);"
                                                @click="generateSystemLIB"
                                                class="
                                                    font-size-12
                                                    text-dark
                                                    hoverable-link
                                                "
                                                >System LIB</a
                                            >
                                        </div>
                                        <hr class="my-1" /> -->
                                        <div >
                                            <a
                                                href="javascript:void(0);"
                                                @click="generateSystemKPI"
                                                class="
                                                    font-size-12
                                                    text-dark
                                                    hoverable-link
                                                    d-block
                                                "
                                                >Cascaded KPI Targets</a
                                            >
                                            <hr class="my-1">
                                            <a
                                                href="javascript:void(0);"
                                                @click="generateApprovedKPI"
                                                class="
                                                    font-size-12
                                                    text-dark
                                                    hoverable-link
                                                    d-block
                                                "
                                                >Approved KPI Targets</a
                                            >
                                        </div>
                                    </div>
                                </slide>
                                <slide>
                                    <div v-if="slideNum == 2">
                                        <a href="javascript:void(0);" class="text-dark d-flex align-items-center" @click="goBackToSelection"><i class="bx bx-left-arrow-alt me-1"></i>Go back to selection</a>
                                        <div v-if="campusSelection">
                                            <select class="form-select mt-2 mb-2" v-model="groupCampus">
                                                <option value="">Select Campus</option>
                                                <option value="all" v-if="reportType !== 'campus'">All</option>
                                                <option v-for="x in allCampus" :key="x.Id" :value="x.Id">{{x.CampusName}}</option>
                                            </select>
                                            <button type="button" @click="generateCampusLIB" class="btn btn-purple btn-sm btn-block mt-2" v-if="groupCampus > 0 && reportType === 'campus'"><i class="bx bx-printer me-1"></i> Print Report</button>
                                            <button type="button" @click="generateCascadeReport" class="btn btn-purple btn-sm btn-block mt-2" v-if="groupCampus !== '' && reportType === 'cascaded'"><i class="bx bx-printer me-1"></i> Print Report</button>
                                            <button type="button" @click="generateKPIReport" class="btn btn-purple btn-sm btn-block mt-2" v-if="groupCampus !== '' && reportType === 'kpi'"><i class="bx bx-printer me-1"></i> Print Report</button>
                                        </div>
                                    </div>
                                </slide>
                            </carousel>
                        </b-popover>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <template v-for="w in filtered">
                    <div :key="w.id">
                        <div class="d-flex align-items-center">
                            <div style="width:10px;height:10px;border-radius:50%;" class="bg-success me-1"></div>
                            <h4 class="my-2">{{w.prexcClass}}</h4>
                        </div>
                        <div class="ms-4">
                            <template v-for="z in filteredPrexc(w.items)">
                                <b-card
                                    :key="z.id"
                                    no-body
                                    class="mb-1 shadow-none"
                                >
                                    <b-card-header
                                        header-tag="header"
                                        role="tab"
                                        class="border"
                                    >
                                        <div
                                            class="
                                                d-flex
                                                justify-content-between
                                                align-items-center
                                            "
                                        >
                                            <div class="d-flex align-items-start">
                                                <div style="width: 5px;height:5px;" class="bg-warning bg-gradient text-center me-2 mt-1"></div>
                                                <div class="text-muted">
                                                    <h5 class="mb-0 line-height-1 hover-underline cursor-pointer" @click="showGrpDtls(z)">
                                                        {{ z.prexc }}
                                                    </h5>
                                                </div>
                                            </div>
                                            <div>
                                                <a href="javascript:void(0)" @click="showGrpDtls(z)">
                                                    <i class="bx  font-size-24" :class="[z.rotateChevy ? 'bx-chevron-down' : 'bx-chevron-right']"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </b-card-header>
                                    <b-collapse
                                        :visible="z.rotateChevy"
                                        :accordion="`prexc-${z.id}`"
                                        role="tabpanel"
                                    >
                                        <b-card-body class="border">
                                            <b-tabs
                                                pills
                                                vertical
                                                nav-class="p-0"
                                                nav-wrapper-class="col-sm-2"
                                                content-class="pt-0 px-2 text-muted border-start"
                                            >
                                                <b-tab title-item-class="mb-2" v-for="x in filteredTab(z.items)" :key="x.id" @click="getIndicatorItems(x)" >
                                                    <template v-slot:title>{{x.indicatorName}}</template>
                                                    <div class="mb-2 d-flex justify-content-between align-items-center">
                                                        <h5 class="mb-0">KPI List</h5>
                                                        <!-- <input type="text" class="form-control form-control-sm me-1" placeholder="Search KPI..." v-model="x.searchFilter" style="width:250px;"> -->
                                                    </div>
                                                    <template v-if="!z.indicatorItemLoading">
                                                        <div class="card mb-2" v-for="(y, yIndex) in filteredIndicatorItems(x.fetchedIndicatorItems)" :key="`A${x.id}-B${y.id}`" :style="`z-index: ${x.indicatorItems.length - yIndex}`">
                                                            <div class="card-header">
                                                                <div class="text-muted">
                                                                    <div class="d-flex w-100">
                                                                        <h5 class="mb-0 d-inline">{{y.indicatorItemName}}</h5>
                                                                        <span class="font-size-12 text-yellow ms-1" v-if="y.code">
                                                                            [{{ y.code }}]
                                                                        </span>
                                                                        <span 
                                                                            class="badge bg-purple ms-2"
                                                                            style="vertical-align: top"
                                                                        >
                                                                            {{ y.indicatorItemClassification.classification}}
                                                                        </span>
                                                                        <span 
                                                                            class="badge bg-dark ms-2 text-white"
                                                                            style="vertical-align: top"
                                                                        >
                                                                            {{ y.type}}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <small class="d-flex align-items-center">
                                                                        <a
                                                                            href="javascript: void(0);"
                                                                            class="text-success d-flex align-items-center ms-1"
                                                                            @click="viewMainTargets(y)"
                                                                        >
                                                                            {{ y.visible ? "Hide" : "Show" }}
                                                                            Main Targets
                                                                            <i 
                                                                                class="bx bx-chevron-right rotate font-size-14"
                                                                                :class="{'rotate-90': y.visible}"
                                                                            ></i>
                                                                        </a>
                                                                    </small>
                                                                </div>
                                                            </div>
                                                            <b-collapse
                                                                :visible="y.visible"
                                                                :accordion="`detail-accordion-${y.id}`"
                                                                role="tabpanel"
                                                            >
                                                                <b-card-body
                                                                    class="border my-2"
                                                                >
                                                                    <div class="d-flex align-items-end justify-content-between">
                                                                        <h4 class="m-0">Main Target List</h4>
                                                                        <div class="d-flex">
                                                                            <button
                                                                                type="button"
                                                                                class="btn btn-primary"
                                                                                @click="createNewTarget(y)"
                                                                            >
                                                                                <i class="bx bx-plus"></i>Create New Target Template
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        v-if="y.mainTargetLoading" 
                                                                        class="
                                                                            d-flex
                                                                            justify-content-center
                                                                            align-items-center
                                                                            my-5
                                                                        "
                                                                    >
                                                                        <div class="preloader-component me-2">
                                                                            <div class="status">
                                                                                <div class="spinner-chase w-20px h-20px">
                                                                                    <div class="chase-dot"></div>
                                                                                    <div class="chase-dot"></div>
                                                                                    <div class="chase-dot"></div>
                                                                                    <div class="chase-dot"></div>
                                                                                    <div class="chase-dot"></div>
                                                                                    <div class="chase-dot"></div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <strong>Loading...</strong>
                                                                    </div>
                                                                    <div v-else>
                                                                        <main-target-template 
                                                                            :fromTemplate="false"
                                                                            :singleSelection="true"
                                                                            :mainTargets="y.mainTargets" 
                                                                            :mandatory="y.indicatorItemClassification.classification.toLowerCase().includes('mandatory') ? true : false"
                                                                            @delete="deleteIndicatorItem($event, y)" 
                                                                            @post="postIndicatorItem($event, y)"
                                                                            @update="updateIndicatorItem($event, y)"
                                                                            @open-imports="openImports($event, y)"
                                                                            :ref="`mainTargetTemplate${y.id}`"
                                                                            @view-apis="viewAPIs"
                                                                        ></main-target-template>
                                                                    </div>
                                                                </b-card-body>
                                                            </b-collapse>
                                                        </div>
                                                    </template>
                                                    <div v-else class="mt-1">
                                                        <b-skeleton
                                                            width="100px"
                                                            height="10px"
                                                        ></b-skeleton>
                                                    </div>
                                                </b-tab>
                                            </b-tabs>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </template>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <api-type @dropData="dropType($event)"></api-type>
    </div>
</template>